import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FlowUiState } from 'src/lib/flow';
import { EvaluatedFlowPage } from 'src/lib/flow/FlowPage';

const initialState: Omit<FlowUiState, 'page'> & {
  page?: EvaluatedFlowPage;
  pageLoading: boolean;
  flowInitialized: boolean;
  pageError?: string;
  showValidation: boolean;
} = {
  // From FlowUiState
  progress: { current: 0, total: 10, enabledPages: [] },
  canAdvance: false,
  canAutoAdvance: false,
  isReadyForAutoSubmit: false,
  pageIndex: -1,
  page: undefined,
  previousPage: null,

  // Additional Ui state flags
  pageLoading: false,
  flowInitialized: false,
  pageError: undefined,
  showValidation: false,
};

const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showValidation: (state) => {
      state.showValidation = true;
    },
    clearValidation: (state) => {
      state.showValidation = false;
    },
    //FIXME: remove when we've fixed doPageLater
    flowInitialized: (state) => {
      state.flowInitialized = true;
    },
    startPageLoading: (state) => {
      state.pageLoading = true;
    },
    endPageLoading: (state) => {
      state.pageLoading = false;
    },
    submitAndGoToNextPage: (
      state,
      _action: PayloadAction<{ additionalAnswerKeysToSubmit: Array<string> } | undefined>,
    ) => {
      state.pageLoading = true;
    },
    // used in account_form to handle it's own submit and advance page
    // while these events are no-ops here, they trigger a series of event dispatches
    // in flow_listeners
    //
    // submitAnswers accepts an array of answer keys that will submitted with
    // the page even if they do not show up in the page's question tree. This
    // is used on the account page since it is a very special case.
    submitAnswers: (
      _,
      _action: PayloadAction<{ additionalAnswerKeysToSubmit: Array<string> } | undefined>,
    ) => {},
    goToNextPage: () => {
      // clear showValidation here?
    },
    updateUi: (state, action: PayloadAction<FlowUiState & { pageLoading?: boolean }>) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
      });
    },
  },
});

export const {
  updateUi,
  startPageLoading,
  endPageLoading,
  submitAndGoToNextPage,
  submitAnswers,
  goToNextPage,
  flowInitialized,
  showValidation,
  clearValidation,
} = slice.actions;

export default slice.reducer;
